// @ts-check
/**
 * @file recurrenceLabels.js
 * @location src/utils/recurrenceLabels.js
 * @role 반복 규칙 → 사람이 읽는 표시 라벨 (UI 전용·코스메틱). 생성 엔진(recurrence.js)과 분리.
 */
import { WEEKDAY_LABELS } from '../data/labels.js';

/**
 * 반복 규칙 → 사람이 읽는 라벨. 일람·요약 표시용.
 * @param {import('../data/types.js').TaskRepeat|null|undefined} repeat
 * @returns {string}
 */
export function recurrenceLabel(repeat) {
  switch (repeat?.freq) {
    case 'daily':
      return '매일';
    case 'weekly': {
      const days = [...(repeat.weekdays ?? [])].sort((a, b) => a - b).map(w => WEEKDAY_LABELS[w] ?? '?').join('·');
      const iv = repeat.interval ?? 1;
      const prefix = iv <= 1 ? '매주' : iv === 2 ? '격주' : `${iv}주마다`;
      return `${prefix} ${days}`;
    }
    case 'monthly':
      if ('nth' in repeat) {
        const nl = repeat.nth === 'last' ? '마지막' : `${repeat.nth}번째`;
        return `매월 ${nl} ${WEEKDAY_LABELS[repeat.weekday] ?? '?'}요일`;
      }
      return `매월 ${repeat.day ?? 1}일`;
    default:
      return '';
  }
}

/**
 * 반복 빈도 → 한 글자 주기 마크(일/주/월). 루틴 카드 주기 박스용(아이콘 대체).
 * @param {import('../data/types.js').TaskRepeat|null|undefined} repeat
 * @returns {string}
 */
export function recurrenceFreqMark(repeat) {
  switch (repeat?.freq) {
    case 'daily':   return '일';
    case 'weekly':  return '주';
    case 'monthly': return '월';
    default:        return '';
  }
}

/**
 * 그룹 헤더가 freq를 말할 때 행에 보일 세부 — weekly:요일, monthly:N일, daily:''(빈).
 * @param {import('../data/types.js').TaskRepeat|null|undefined} repeat
 * @returns {string}
 */
export function recurrenceDetail(repeat) {
  switch (repeat?.freq) {
    case 'weekly':
      return [...(repeat.weekdays ?? [])].sort((a, b) => a - b).map(w => WEEKDAY_LABELS[w] ?? '?').join('·');
    case 'monthly':
      if ('nth' in repeat) {
        const nl = repeat.nth === 'last' ? '마지막' : `${repeat.nth}번째`;
        return `${nl} ${WEEKDAY_LABELS[repeat.weekday] ?? '?'}`;
      }
      return `${repeat.day ?? 1}일`;
    default:
      return '';
  }
}
